/**
 * TYMO BEAUTY LLC - Shopify Theme Custom JavaScript
 * Vanilla JavaScript Implementation of React Frontend Interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Header scroll effect
  const header = document.querySelector('.tb-header');
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 15) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // 2. Mobile menu toggle
  const menuToggle = document.querySelector('.tb-menu-toggle');
  const mobileDrawer = document.querySelector('.tb-mobile-drawer');
  if (menuToggle && mobileDrawer) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileDrawer.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
      
      // Update hamburger icon to X or vice-versa
      const iconSvg = menuToggle.querySelector('svg');
      if (iconSvg) {
        if (isOpen) {
          iconSvg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />';
        } else {
          iconSvg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />';
        }
      }
    });

    // Close on link click
    mobileDrawer.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileDrawer.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // 3. FAQ Accordion
  const faqItems = document.querySelectorAll('.tb-faq-item');
  faqItems.forEach(item => {
    const trigger = item.querySelector('.tb-faq-trigger');
    if (trigger) {
      trigger.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        // Optionally close other items
        faqItems.forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
            const otherBtn = other.querySelector('.tb-faq-trigger');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        if (isActive) {
          item.classList.remove('active');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('active');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });

  // 4. Cookie Consent Banner
  const cookieBanner = document.querySelector('.tb-cookie-banner');
  if (cookieBanner) {
    const consentKey = 'tymo_beauty_cookie_consent';
    const savedConsent = localStorage.getItem(consentKey);

    if (!savedConsent) {
      setTimeout(() => {
        cookieBanner.classList.add('show');
      }, 1000);
    }

    const acceptBtn = cookieBanner.querySelector('[data-cookie-accept]');
    const rejectBtn = cookieBanner.querySelector('[data-cookie-reject]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', () => {
        const consent = {
          essential: true,
          analytics: true,
          marketing: true,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem(consentKey, JSON.stringify(consent));
        cookieBanner.classList.remove('show');
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', () => {
        const consent = {
          essential: true,
          analytics: false,
          marketing: false,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem(consentKey, JSON.stringify(consent));
        cookieBanner.classList.remove('show');
      });
    }
  }

  // 5. Contact / Audit Form Handling
  const contactForm = document.querySelector('.tb-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      const emailInput = contactForm.querySelector('input[type="email"]');
      if (emailInput && !emailInput.value.includes('@')) {
        e.preventDefault();
        alert('Please enter a valid work email address.');
        emailInput.focus();
      }
    });
  }

  // 6. Smooth scroll for anchor links (#services, etc.)
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          const headerHeight = header ? header.offsetHeight : 80;
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});
